import { render, staticRenderFns } from "./ElementScaleTypeTableColumn.vue?vue&type=template&id=ea84849a"
import script from "./ElementScaleTypeTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementScaleTypeTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports